<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title">
      {{ 'Participate in election' | translate }}
    </h3>
  </div>

  <div class="modal-body">

    <p>
      {{ 'Select an election and region for company to subscribe' | translate }}
    </p>

    <div class="" *ngIf="companyId">

      <div class="form-group">
        <label class="font-weight-bold label"> {{ 'Company' | translate}}</label>
        <div>
          {{ company.name}}
        </div>
      </div>

      <div class="form-group">
        <label class="font-weight-bold label">{{ 'Election' | translate}} *</label>
        <select class="form-control" [(ngModel)]="electionId" (ngModelChange)="setAreas($event)">
          <option></option>
          <option [value]="election.id" *ngFor="let election of elections">
            {{ election.title }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="font-weight-bold label">{{ 'Region' | translate}} *</label>
        <select class="form-control" [(ngModel)]="areaId">
          <option></option>
          <option [value]="area.id" *ngFor="let area of areas">
            {{ area.name }}
          </option>
        </select>
      </div>

    </div>

  </div>

  <div class="modal-footer d-flex justify-content-between">

    <button class="btn btn-secondary" type="button" (click)="activeModal.close(false)">
      {{ 'Cancel' | translate }}
    </button>


    <button (click)="signUp()" type="button" *ngIf="valid()" class="btn btn-primary">
      {{ 'Sign up' | translate }}
    </button>

  </div>

</div>

